<script>
import BaseComponent from 'primevue/basecomponent';
import CardStyle from 'primevue/card/style';

export default {
    name: 'BaseCard',
    extends: BaseComponent,
    style: CardStyle
};
</script>
